//公共组件
// elementPlus组件
import { initElementPlusUI } from "./elementPlus/elementPlus";
export function initComponents(app) {
  initElementPlusUI(app);
}
